module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@3x-35b5ac209e546a55c7a420ee1fca8cfc.png";